const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-HTML',
			DefaultInputExtensions: [ 'Bulma-HTML' ],
			Template: /*HTML*/`
			<!-- InputType HTML {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
					<span class="icon">
						<i class="fas fa-fw fa-exclamation-triangle"></i>
					</span>
					<span class="icon-text">No HTML content available to display.</span>
				</div>
				<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-html {~ShowContent:Record~}"></div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-HTML',
			DefaultInputExtensions: [ 'Bulma-HTML' ],
			Template: /*HTML*/`
			<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
						<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
							<span class="icon">
								<i class="fas fa-fw fa-exclamation-triangle"></i>
							</span>
							<span class="icon-text">No HTML content available to display.</span>
						</div>
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-html {~ShowContent:Record~}"></div>
					</div>
				</div>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-HTML',
			DefaultInputExtensions: [ 'Bulma-HTML' ],
			Template: /*HTML*/`
			<!-- InputType HTML {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
				<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
					<span class="icon">
						<i class="fas fa-fw fa-exclamation-triangle"></i>
					</span>
					<span class="icon-text">No HTML content available to display.</span>
				</div>
				<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-html {~ShowContent:Record~}"></div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-HTML',
			DefaultInputExtensions: [ 'Bulma-HTML' ],
			Template: /*HTML*/`
			<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
						<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
							<span class="icon">
								<i class="fas fa-fw fa-exclamation-triangle"></i>
							</span>
							<span class="icon-text">No HTML content available to display.</span>
						</div>
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-html {~ShowContent:Record~}"></div>
					</div>
				</div>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-HTML',
			DefaultInputExtensions: [ 'Bulma-HTML' ],
			Template: /*HTML*/`
			<!-- InputType HTML {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
					<span class="icon">
						<i class="fas fa-fw fa-exclamation-triangle"></i>
					</span>
					<span class="icon-text">No HTML content available to display.</span>
				</div>
				<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-html {~ShowContent:Record~}"></div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-HTML',
			DefaultInputExtensions: [ 'Bulma-HTML' ],
			Template: /*HTML*/`
			<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div {~D:Record.Macro.ControlAttr~} class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
						<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="notification p-5 mb-0 has-text-centered {~HideContent:Record~}">
							<span class="icon">
								<i class="fas fa-fw fa-exclamation-triangle"></i>
							</span>
							<span class="icon-text">No HTML content available to display.</span>
						</div>
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-html {~ShowContent:Record~}"></div>
					</div>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
